import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

import styles from './realty-header.module.css';

export type RealtyHeaderLogoProps = {
  generalLayout: GeneralLayout['data'];
};

export function RealtyHeaderLogo({ generalLayout }: RealtyHeaderLogoProps) {
  const logo = generalLayout.header?.logo;
  const logoSrc = logo?.url?.trim();
  const logoAlt = (generalLayout.site_name?.trim() || '') || logo?.custom_title?.trim() || '';

  return (
    <Link
      href={ROUTES.HOME() || '/'}
      className={`${styles.logoLink} ea-realty-header-logo`}
      data-eli-part="logo"
      prefetch={false}
    >
      {logoSrc ? (
        <Image
          src={logoSrc}
          alt={resolveImageAlt(logo, logoAlt)}
          width={113}
          height={64}
          sizes="(min-width: 1280px) 113px, 85px"
          className={`${styles.logoImage} ea-realty-header-logo__image`}
        />
      ) : (
        <span className={`${styles.logoFallback} ea-realty-header-logo__text`}>
          {(generalLayout.site_name?.trim() || '')}
        </span>
      )}
    </Link>
  );
}
